import React from "react";
import useConditionalTranslation from "@/utils/hooks/useConditionalTranslation";
import "./MelaInput.css";

interface MelaErrorTextProps {
  errorText?: React.ReactNode;
  id?: string;
  dataTestId?: string;
  className?: string;
}

export const MelaErrorText: React.FC<MelaErrorTextProps> = ({
  errorText,
  id,
  dataTestId,
  className = "",
}) => {
  const isString = typeof errorText === "string";
  const translatedError = useConditionalTranslation(isString ? errorText : "");

  if (!errorText) return null;

  return (
    <span
      id={id}
      className={`mela-input__error-text ${className}`}
      data-testid={dataTestId}
    >
      {isString ? translatedError : errorText}
    </span>
  );
};
